import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminVideoVotingListScreen() {
    const { VideoVotingListScreen } = useModule(adminModuleQuery);
    return <VideoVotingListScreen />;
}
